import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "./firebase"; // Adjust the path based on your folder structure

// ---------- FORM DATA ----------
export const saveFormData = async (data) => {
  const user = auth.currentUser;
  if (!user) return;
  const docRef = doc(db, "proUsers", user.uid);
  await setDoc(docRef, { formData: data }, { merge: true });
};

export const loadFormData = async () => {
  const user = auth.currentUser;
  if (!user) return null;
  const docRef = doc(db, "proUsers", user.uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().formData || null;
  }
  return null;
};

// ---------- TODOS ----------
export const saveTodos = async (todos) => {
  const user = auth.currentUser;
  if (!user) return;
  const docRef = doc(db, "proUsers", user.uid);
  await setDoc(docRef, { todos }, { merge: true });
};

export const loadTodos = async () => {
  const user = auth.currentUser;
  if (!user) return [];
  const docRef = doc(db, "proUsers", user.uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().todos || [];
  }
  return [];
};
